import { render, staticRenderFns } from "./examVideo.vue?vue&type=template&id=623adf59&scoped=true&"
import script from "./examVideo.vue?vue&type=script&lang=js&"
export * from "./examVideo.vue?vue&type=script&lang=js&"
import style0 from "./examVideo.vue?vue&type=style&index=0&id=623adf59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623adf59",
  null
  
)

export default component.exports